import React, { useState } from "react";
import { FaChevronDown } from "react-icons/fa"; // dropdown icon
import { motion } from "framer-motion";

const FaqSection = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const faqData = [
    {
      question: "Where does Vikash Foundation operate and who benefits from its programs?",
      answer:
        "The foundation primarily operates across Odisha, supporting children with disabilities, elderly individuals, and vulnerable families. Through therapy, education, skill training, and community-based care initiatives we have made dreams come true.",
    },
    {
      question: "How can I volunteer or contribute to Vikash Foundation’s initiatives?",
      answer:
        "You can join as a volunteer, sponsor a child or project, or make donations through our official website or local outreach programs. Every contribution helps create inclusive opportunities for those in need.",
    },
    {
      question: "What types of programs does Vikash Foundation run?",
      answer:
        "Vikash Foundation conducts diverse programs, including disability rehabilitation, inclusive education, elderly care, and early childhood development. There are also well-planned women empowerment initiatives and livelihood training to promote independence and dignity across all age groups.",
    },
  ];

  const toggleAccordion = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <section id="fq" className="faq-one">
      <div className="shape2 float-bob-y">
        <img src="assets/images/shapes/faq-v1-shape2.png" alt="" />
      </div>
      <div className="container">
        <div className="row">
          {/* FAQ Content */}
          <div className="col-xl-6">
            <div className="faq-one__content">
              <div className="sec-title sec-title-animation animation-style2">
                <div className="sec-title__tagline">
                  <div className="left-line" />
                  <div className="text">
                    <h4>Frequently Asked Questions</h4>
                  </div>
                </div>
                <h2 className="sec-title__title title-animation">
                 Everything You Want to Know About Us
                </h2>
              </div>

              <div className="faq-one__content-faq">
                <div className="faq-one-accrodion">
                {faqData.map((item, index) => (
                  <motion.div
                    key={index}
                    layout
                    initial={{ opacity: 0, y: 18 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, amount: 0.2 }}
                    transition={{ duration: 0.5, ease: "easeOut" }}
                    className={`accrodion ${activeIndex === index ? "active" : ""}`}
                  >
                    <motion.div
                      layout
                      className="accrodion-title d-flex justify-content-between align-items-center faq-card"
                      onClick={() => toggleAccordion(index)}
                      role="button"
                      tabIndex={0}
                      onKeyDown={(e) => {
                        if (e.key === "Enter" || e.key === " ") toggleAccordion(index);
                      }}
                    >
                      <h4>{item.question}</h4>

                      <motion.div
                        className={`faq-icon ${activeIndex === index ? "rotate" : ""}`}
                        animate={{ rotate: activeIndex === index ? 180 : 0 }}
                        transition={{ duration: 0.3 }}
                      >
                        <FaChevronDown size={18} />
                      </motion.div>
                    </motion.div>

                    <motion.div
                      className="accrodion-content"
                      layout
                      initial={false}
                      animate={{ height: activeIndex === index ? "auto" : 0, opacity: activeIndex === index ? 1 : 0 }}
                      transition={{ duration: 0.4, ease: "easeInOut" }}
                      style={{ overflow: "hidden" }}
                    >
                      <div className="inner">
                        <p>{item.answer}</p>
                      </div>
                    </motion.div>
                  </motion.div>
                ))}
                </div>
              </div>
            </div>
          </div>

          {/* FAQ Image */}
          <div className="col-xl-6">
            <div className="faq-one__img clearfix">
              <div className="faq-one__img1">
                <img src="assets/images/resources/fa-v1-img1.png" alt="" />
                <div className="shape1">
                  <img src="assets/images/shapes/faq-v1-shape1.png" alt="" />
                </div>
              </div>
              <div className="faq-one__img2">
                <img src="assets/images/resources/fa-v1-img2.png" alt="" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FaqSection;
